import React from 'react';
import ReactModal from 'react-modal';
import useFilterModal from 'hooks/useFilterModal';
import { NormalizedProduct } from '../../../../@types/woocommerce';
import { TotalPriceSectionModalContent } from '../TotalPriceSection';

ReactModal.setAppElement('#root');

type Props = {
  products: { product: NormalizedProduct; quantity: number }[];
};

const TotalPriceModal = ({ products, ...props }: Partial<ReactModal.Props> & Props) => {
  const { isOpen, closeModal, modalStyles } = useFilterModal();

  return (
    <ReactModal
      {...props}
      isOpen={isOpen}
      onRequestClose={() => closeModal()}
      style={modalStyles}
      closeTimeoutMS={350}
    >
      <TotalPriceSectionModalContent products={products} />
    </ReactModal>
  );
};

export default TotalPriceModal;
